import {
  UnifiedMonitoringAlarmCountMessage,
  UnifiedMonitoringAlarmGroupsMessage,
  UnifiedMonitoringAlarmGroupStatusMessage,
  UnifiedMonitoringAlarmsMessage,
  UnifiedMonitoringInboundMessage,
  UnifiedMonitoringLLMRecommendationMessage,
  UnifiedMonitoringMessageType,
} from '@hakimo-ui/hakimo/types';
import { useUnifiedMonitoringWs } from '@hakimo-ui/hakimo/util';
import { useEffect } from 'react';

type MessageTypeMap = {
  [UnifiedMonitoringMessageType.ALARM_COUNT]: UnifiedMonitoringAlarmCountMessage;
  [UnifiedMonitoringMessageType.UNIFIED_ALARM_GROUPS]: UnifiedMonitoringAlarmGroupsMessage;
  [UnifiedMonitoringMessageType.UNIFIED_ALARMS]: UnifiedMonitoringAlarmsMessage[];
  [UnifiedMonitoringMessageType.LLM_RECOMMENDATION]: UnifiedMonitoringLLMRecommendationMessage[];
  [UnifiedMonitoringMessageType.UNIFIED_ALARM_GROUP_STATUS]: UnifiedMonitoringAlarmGroupStatusMessage;
};

type InBounMessageType =
  | UnifiedMonitoringMessageType.ALARM_COUNT
  | UnifiedMonitoringMessageType.UNIFIED_ALARMS
  | UnifiedMonitoringMessageType.UNIFIED_ALARM_GROUPS
  | UnifiedMonitoringMessageType.LLM_RECOMMENDATION
  | UnifiedMonitoringMessageType.UNIFIED_ALARM_GROUP_STATUS;

export function useUnifiedMonitoringWsMessageHandler<
  T extends InBounMessageType
>(messageType: T, handler: (data: MessageTypeMap[T]) => void) {
  const { subscribe } = useUnifiedMonitoringWs();

  useEffect(() => {
    // Subscribe to messages with type 'update' (or any other topic)
    const unsubscribe = subscribe?.(
      messageType,
      handler as (data: UnifiedMonitoringInboundMessage) => void
    );
    return () => {
      unsubscribe?.();
    };
  }, [handler, messageType, subscribe]);
}
